.focused,
.focusable:focus-visible,
.focusable-focus:focus,
.focusable-within:focus-within,
.has-focusable-input:has(input:focus-visible),
.focusable-sibling:focus-visible + .focus-styled-sibling {
  outline: var(--dds-focus-outline);
  outline-offset: var(--dds-focus-outline-offset);
  box-shadow: var(--dds-focus-box-shadow);
}

.focusable--inset:focus-visible {
  outline: var(--dds-focus-outline);
  outline-offset: var(--dds-focus-outline-inset);
  box-shadow: var(--dds-focus-box-shadow);
}
